module.exports = __webpack_public_path__ + "img/2.615d4a3b.png";